import { DateTime } from "luxon";
import { DetectRolld } from "../../mixins/detectRolld";
import store from "../../store";

const isRolld = DetectRolld.methods.isRolldStore();

export const weekdays = {
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
  7: "sunday",
};
function wholeDateIsBlackout(blackoutDates, dateTime) {
  if (!blackoutDates) return false;
  for (let i = 0; i < blackoutDates.length; i++) {
    const parsed = DateTime.fromISO(blackoutDates[i].Date);
    const sameDate =
      parsed.year === dateTime.year && parsed.ordinal === dateTime.ordinal;
    if (sameDate) {
      return true;
    }
  }
  return false;
}
export function setZone(time, zone) {
  if (zone && time.setZone(zone).isValid) {
    return time.setZone(zone, { keepLocalTime: true });
  }
  return time;
}
function applyBlackoutToOperatingHours(
  blackoutDates,
  operatingHours,
  dateTime
) {
  if (wholeDateIsBlackout(blackoutDates, dateTime)) {
    return null;
  } else {
    return operatingHours;
  }
}

export function getCurrentDate(zone) {
  let now = DateTime.fromJSDate(getServerTime());
  if (zone && now.setZone(zone).isValid && now.zoneName !== zone) {
    return now.setZone(zone);
  }
  return now;
}
export function getCustomDate(date, zone) {
  let now = DateTime.fromJSDate(date, { zone: zone });
  if (zone && now.setZone(zone).isValid && now.zoneName !== zone) {
    return now.setZone(zone);
  }
  return now;
}
export function isTimestampAfterCurrentDate(timeStampSecond, currentDateZone) {
  if (!timeStampSecond) return false;
  let now = getCurrentDate(currentDateZone);
  if (timeStampSecond instanceof DateTime) return timeStampSecond > now;
  return DateTime.fromJSDate(new Date(timeStampSecond * 1000)) >= now;
}

export function isTimestampAfterDate(time, timeStampSecond, currentDateZone) {
  if (!timeStampSecond || !time) return false;
  return timeStampSecond * 1000 > time.setZone(currentDateZone).ts;
}

export function isTimestrAfterCurrentDate(timeStr, currentTimeStr) {
  if (!timeStr || !currentTimeStr) {
    return false;
  }
  let result =
    DateTime.fromFormat(timeStr, "HH:mm:ss") >=
    DateTime.fromFormat(currentTimeStr, "HH:mm:ss");
  return result;
}

export function isMenuAvailable(now, menuTimeSetting) {
  return (
    (!isTimestrAfterCurrentDate(
      menuTimeSetting.StartTime,
      now.toFormat("HH:mm:ss")
    ) &&
      isTimestrAfterCurrentDate(
        menuTimeSetting.EndTime,
        now.toFormat("HH:mm:ss")
      )) ||
    menuTimeSetting.dateTime > now
  );
}

export function getTimeDifference(time1, time2) {
  if (!time1 || !time2) return 0;

  return DateTime.fromFormat(time1, "HH:mm:ss")
    .diff(DateTime.fromFormat(time2, "HH:mm:ss"))
    .as("minutes");
}

export function operatingHours(blackoutDates, date, operatingHours) {
  if (!date || !operatingHours || operatingHours.length == 0 || !date.isValid) {
    return {
      openTime: null,
      closeTime: null,
    };
  }
  let operatinHour = "";
  operatingHours.forEach((item) => {
    if (item.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()) {
      operatinHour = item;
    }
  });
  if (operatinHour && operatinHour.OpeningTime && operatinHour.ClosingTime) {
    if (
      !DateTime.fromFormat(operatinHour.OpeningTime, "HH:mm:ss").isValid ||
      !DateTime.fromFormat(operatinHour.ClosingTime, "HH:mm:ss").isValid
    ) {
      return {
        openTime: null,
        closeTime: null,
      };
    } else if (wholeDateIsBlackout(blackoutDates, date)) {
      return null;
    }
    operatinHour = applyBlackoutToOperatingHours(
      blackoutDates,
      operatinHour,
      date
    );
    if (
      operatinHour === null ||
      !DateTime.fromFormat(operatinHour.OpeningTime, "HH:mm:ss").isValid ||
      !DateTime.fromFormat(operatinHour.ClosingTime, "HH:mm:ss").isValid
    ) {
      return null;
    }

    var operationTime = {
      openTime: DateTime.fromFormat(
        operatinHour.OpeningTime,
        "HH:mm:ss"
      ).toFormat("hh:mm a"),
      closeTime: DateTime.fromFormat(
        operatinHour.ClosingTime,
        "HH:mm:ss"
      ).toFormat("hh:mm a"),
    };
    return operationTime;
  }
  return null;
}

export function extractTimeSlotInDate(
  blackoutDates,
  deliveryTimeSlots,
  dpDate,
  operatinHours
) {
  if (
    !deliveryTimeSlots ||
    deliveryTimeSlots.length == 0 ||
    !dpDate ||
    !operatinHours
  ) {
    return null;
  }
  var date = DateTime.fromISO(DateTime.fromJSDate(dpDate).toISODate());
  let allOperatingHours;
  if (operatinHours.secondOperatingHours) {
    const secondOperatingHours = { ...operatinHours.secondOperatingHours };
    // delete operatinHours.secondOperatingHours;
    allOperatingHours = [operatinHours, secondOperatingHours];
  } else {
    operatinHours = applyBlackoutToOperatingHours(
      blackoutDates,
      operatinHours,
      date
    );
    if (
      operatinHours === null ||
      !DateTime.fromFormat(operatinHours.OpeningTime, "HH:mm:ss").isValid ||
      !DateTime.fromFormat(operatinHours.ClosingTime, "HH:mm:ss").isValid
    ) {
      return null;
    }
    allOperatingHours = [operatinHours];
  }
  let slots = [];

  allOperatingHours.forEach((operatinHours) => {
    let openingTime = DateTime.fromFormat(
      operatinHours.OpeningTime,
      "HH:mm:ss"
    );
    let closingTime = DateTime.fromFormat(
      operatinHours.ClosingTime,
      "HH:mm:ss"
    );
    deliveryTimeSlots
      .filter(
        (p) => p.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()
      )
      .sort((a, b) => {
        let aStart = DateTime.fromFormat(a.StartTime, "HH:mm:ss");
        let bStart = DateTime.fromFormat(b.StartTime, "HH:mm:ss");
        return aStart > bStart ? 1 : -1;
      })
      .forEach((item) => {
        let startTime = DateTime.fromFormat(item.StartTime, "HH:mm:ss");
        let endTime = DateTime.fromFormat(item.EndTime, "HH:mm:ss");
        if (endTime > openingTime) {
          slots.push({
            OpeningTime:
              openingTime > startTime
                ? openingTime.toFormat("HH:mm:ss")
                : item.StartTime,
            ClosingTime:
              closingTime < endTime ? operatinHours.ClosingTime : item.EndTime,
            DayOfWeek: item.DayOfWeek,
          });
        }
      });
  });
  return slots;
}

export function initPickupDeliveryTimes(
  selectedTs,
  preparationDeliveryBuffer,
  blackoutDates,
  isPickupMode,
  isDoorDash = false,
  operatingHours,
  orderPreparationTime,
  dpDate,
  localDate,
  estimateDeliverTime,
  selectUpperTime = true,
  timeInterval = 15,
  deliveryTimeSlots = null,
  isDeliveryTimeSlotsEnable = false,
  preOrderCutOffTime
) {
  // quick fix to client wrong date time
  if (getServerTime() > dpDate) {
    dpDate = getServerTime();
  }
  if (
    orderPreparationTime < 0 ||
    ((!Array.isArray(operatingHours) || operatingHours.length == 0) &&
      (!deliveryTimeSlots || deliveryTimeSlots.length == 0))
  ) {
    return [];
  }

  if (!estimateDeliverTime) {
    estimateDeliverTime = 0;
  } else {
    estimateDeliverTime = parseInt(estimateDeliverTime.toFormat("m"));
  }
  let date = DateTime.fromISO(DateTime.fromJSDate(dpDate).toISODate());
  let operatinHours = [];
  operatingHours.forEach((item) => {
    if (item.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()) {
      const blackedOutOperatingHours = applyBlackoutToOperatingHours(
        blackoutDates,
        item,
        date
      );
      if (blackedOutOperatingHours.secondOperatingHours) {
        const secondOperatingHours = {
          ...blackedOutOperatingHours.secondOperatingHours,
        };
        // delete blackedOutOperatingHours.secondOperatingHours;
        operatinHours.push(blackedOutOperatingHours);
        operatinHours.push(secondOperatingHours);
      } else {
        operatinHours.push(blackedOutOperatingHours);
      }
    }
  });
  if (!operatinHours || operatinHours.length == 0) return [];
  let timeSlots = [];
  operatinHours.forEach((item) => {
    const output = extractTimeSlotInDate(
      blackoutDates,
      deliveryTimeSlots,
      dpDate,
      item
    );
    if (Array.isArray(output)) {
      timeSlots.push(...output);
    }
  });
  if (isDeliveryTimeSlotsEnable) {
    // if (timeSlots && timeSlots.length > 0) {
    operatinHours = timeSlots || [];
    // }
  }
  let times = [];
  operatinHours.forEach((hour) => {
    let startingTime = hour.OpeningTime;
    let closingTime = hour.ClosingTime;
    let closingDateTime = DateTime.fromFormat(
      date.toFormat("dd MMMM yyyy") + " " + closingTime,
      "dd MMMM yyyy hh:mm:ss",
      { zone: localDate.zone }
    );
    let startingDateTime = DateTime.fromFormat(
      date.toFormat("dd MMMM yyyy") + " " + startingTime,
      "dd MMMM yyyy hh:mm:ss",
      { zone: localDate.zone }
    );
    let skip = false;
    if (isDoorDash) {
      // minumum doordash deleverable time is at : 7:30
      let doordashMinTime = date.set({ hour: 7, minute: 30, second: 0 });
      if (startingDateTime < doordashMinTime) {
        startingDateTime = doordashMinTime;
      }
      if (closingDateTime < doordashMinTime) {
        skip = true;
      }
    }
    // time setting constraint
    if (selectedTs && startingDateTime < selectedTs.dateTime) {
      startingDateTime = selectedTs.dateTime;
    }
    if (timeInterval == 0) timeInterval = 15;
    let sameDay =
      localDate.day == startingDateTime.day &&
      localDate.month == startingDateTime.month;
    if (!skip && (localDate <= closingDateTime || !sameDay))
      times = [
        ...times,
        ...populateTimes(
          preparationDeliveryBuffer,
          isPickupMode,
          startingDateTime,
          closingDateTime,
          orderPreparationTime,
          localDate,
          estimateDeliverTime,
          selectUpperTime,
          timeInterval,
          times.length == 0,
          preOrderCutOffTime
        ),
      ];
  });
  return times;
}
export function populateTimes(
  preparationDeliveryBuffer,
  isPickupMode,
  startingDateTime,
  closingDateTime,
  orderPreparationTime,
  localDate,
  estimateDeliverTime,
  selectUpperTime,
  timeInterval,
  isEmpty = false,
  preOrderCutOffTime
) {
  let sameDay =
    localDate.day == startingDateTime.day &&
    localDate.month == startingDateTime.month;
  let times = new Array();
  let orderPrepartionTime = orderPreparationTime || 0;
  let waitTime = orderPrepartionTime;
  if (estimateDeliverTime) waitTime = estimateDeliverTime;

  waitTime = waitTime || 2;
  let nextTime = startingDateTime;
  if (sameDay) {
    if (localDate >= startingDateTime) {
      nextTime = localDate.plus({
        minutes: isPickupMode ? 0 : orderPrepartionTime,
      });
    } else {
      nextTime = startingDateTime;
    }
  } else {
    if (preOrderCutOffTime) {
      nextTime = startingDateTime;
    } else {
      if (localDate.plus({ minutes: waitTime }) >= startingDateTime) {
        nextTime = localDate.plus({ minutes: waitTime });
      } else {
        nextTime = startingDateTime;
      }
    }
  }
  //round
  nextTime = roundTimeToFive(nextTime);
  //pickup
  let slotRange = orderPreparationTime;
  //delivery

  if (estimateDeliverTime) {
    //estimateDeliverTime includes orderPrepartionTime
    slotRange = roundNumberToFive(estimateDeliverTime); //- orderPrepartionTime;
  }
  while (nextTime < closingDateTime) {
    let upperTime = nextTime.plus({ minutes: slotRange });
    if (times.length == 0) {
      if (sameDay) {
        if (localDate < startingDateTime) {
          if (nextTime > closingDateTime) break;
        } else if (nextTime > closingDateTime) {
          break;
        }
        if (localDate >= startingDateTime || isEmpty) {
          if (selectUpperTime) {
            // Add delivery buffer time to range start of ASAP in rolld stores
            const isRolldDelivery = !isPickupMode && isRolld;

            const asapStartTime = isRolldDelivery
              ? nextTime.plus({ minutes: preparationDeliveryBuffer })
              : nextTime;
            const scheduledTime = isRolldDelivery ? asapStartTime : upperTime;

            times.push({
              format: `ASAP (${asapStartTime.toFormat(
                "h:mm a"
              )} - ${upperTime.toFormat("h:mm a")})`,
              time: scheduledTime,
              from: asapStartTime,
              to: upperTime,
            });
          } else {
            const isRolldDelivery = !isPickupMode && isRolld;

            const asapStartTime = isRolldDelivery
              ? nextTime.plus({ minutes: preparationDeliveryBuffer })
              : nextTime;
            const scheduledTime = isRolldDelivery ? asapStartTime : upperTime;
            const format = isRolldDelivery
              ? `ASAP (${asapStartTime.toFormat(
                  "h:mm a"
                )} - ${upperTime.toFormat("h:mm a")})`
              : `ASAP (${upperTime.toFormat("h:mm a")})`;

            times.push({
              format,
              time: scheduledTime,
              from: asapStartTime,
              to: upperTime,
            });
          }
          nextTime = nextTime.plus({ minutes: timeInterval });
          continue;
        }
      }
    }
    let formattedDate = `${nextTime.toFormat("h:mm a")} - ${upperTime.toFormat(
      "h:mm a"
    )}`.toLowerCase();

    const timeEntry = {
      format: formattedDate,
      time: nextTime,
      from: nextTime,
      to: upperTime,
    };
    if (times.length == 0) {
      times.push(timeEntry);
    } else if (nextTime > times[0].time) {
      times.push(timeEntry);
    }
    // plus timeInterval minutes
    nextTime = nextTime.plus({ minutes: timeInterval });
  }
  return times;
}
export function roundTimeToFive(dateTime) {
  let dt = dateTime;
  var minutes = dt.get("minute");
  var rounded = roundNumberToFive(minutes);
  return dt.set({ minute: rounded });
}
export function roundNumberToFive(number) {
  return Math.ceil(number / 5) * 5;
}
export function availablePickupDeliveryDates(
  selectedTS,
  preparationDeliveryBuffer,
  blackoutDates,
  isPickUp,
  isDoorDash = false,
  orderPreparationTime,
  operatinHours,
  isInOperation,
  date,
  numberOfDaysInAdvance = 0,
  preorderEnabled,
  preOrderCutOffDays = 0,
  preOrderCutOffTime = "00:00",
  deliveryTimeSlots,
  isDeliveryTimeSlotsEnable
) {
  if (selectedTS) {
    if (date < selectedTS.dateTime) {
      date = selectedTS.dateTime;
    }
  }
  let startDate = date.plus({ minutes: orderPreparationTime });
  let nextOpenDay = getNexOpenDate(
    blackoutDates,
    operatinHours,
    startDate,
    true,
    deliveryTimeSlots,
    isDeliveryTimeSlotsEnable
  );

  let cutOffTimeEnable = true;
  let cutOffDays = preOrderCutOffDays || 0;
  let cutOffTime = DateTime.fromFormat(
    date.toFormat("dd MMMM yyyy") + " " + (preOrderCutOffTime || "00:00"),
    "dd MMMM yyyy hh:mm",
    { zone: date.zone }
  );

  if (preorderEnabled && cutOffDays && date > cutOffTime) {
    cutOffDays++;
  }
  if (nextOpenDay) {
    if (nextOpenDay.day != date.day) {
      cutOffTimeEnable = false;
      startDate = getNexOpenDate(
        blackoutDates,
        operatinHours,
        cutOffDays > 0 && preOrderCutOffTime
          ? date.plus({
              days: cutOffDays,
            })
          : startDate,
        false,
        deliveryTimeSlots,
        isDeliveryTimeSlotsEnable
      );
    }
  }
  let disableAfter = startDate
    ? startDate.plus({ days: numberOfDaysInAdvance })
    : null;
  let result = createDisableDates(
    selectedTS,
    isPickUp,
    isDoorDash,
    startDate
      ? startDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      : null,
    disableAfter,
    operatinHours,
    isInOperation,
    preparationDeliveryBuffer,
    orderPreparationTime,
    deliveryTimeSlots,
    isDeliveryTimeSlotsEnable,
    cutOffDays,
    preOrderCutOffTime,
    cutOffTimeEnable,
    blackoutDates
  );
  if (cutOffDays) {
    startDate = startDate.plus({
      days: cutOffDays,
    });
  }
  return [result, startDate];
}
export function getNexOpenDate(
  blackoutDates,
  storeOperatingHours,
  startDate,
  sameDay = false,
  deliveryTimeSlots = null,
  isDeliveryTimeSlotsEnable = false
) {
  let index = -1;
  // eslint-disable-next-line no-constant-condition
  while (index < 7) {
    index++;
    const thisDay = startDate.plus({ days: index });
    let todayStr = weekdays[thisDay.weekday];
    let operatinHours = storeOperatingHours.find(
      (p) => p.DayOfWeek.toLowerCase() == todayStr
    );
    operatinHours = applyBlackoutToOperatingHours(
      blackoutDates,
      operatinHours,
      thisDay
    );
    if (
      !operatinHours ||
      !operatinHours.OpeningTime ||
      !operatinHours.ClosingTime
    )
      continue;
    if (isDeliveryTimeSlotsEnable) {
      let slots = extractTimeSlotInDate(
        blackoutDates,
        deliveryTimeSlots,
        thisDay.toJSDate(),
        operatinHours
      );
      if (slots && slots.length > 0) {
        operatinHours = slots[0];
        operatinHours.ClosingTime = slots[slots.length - 1].ClosingTime;
      } else {
        continue;
      }
    }
    let now = thisDay;
    let closing = DateTime.fromFormat(
      now.toFormat("yyyy/MM/dd") + " " + operatinHours.ClosingTime,
      "yyyy/MM/dd hh:mm:ss",
      { zone: startDate.zone }
    );
    if (index > 0) {
      return DateTime.fromFormat(
        now.toFormat("yyyy/MM/dd") + " " + operatinHours.OpeningTime,
        "yyyy/MM/dd hh:mm:ss",
        { zone: startDate.zone }
      );
    }
    if (now <= closing || !sameDay) {
      return now;
    }
  }
}
export function createDisableDates(
  selectedTS,
  isPickup,
  isDoorDash,
  startDate,
  twoWeekAfter,
  operatingHours,
  isInOperation,
  preparationDeliveryBuffer,
  orderPreparationTime,
  deliveryTimeSlots,
  isDeliveryTimeSlotsEnable,
  cutOffDays,
  preOrderCutOffTime,
  cutOffTimeEnable,
  blackoutDates
) {
  return {
    customPredictor: function (date) {
      if (!deliveryTimeSlots && isDeliveryTimeSlotsEnable) return true;
      date = DateTime.fromJSDate(date, { zone: startDate.zone }).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

      if (
        date < startDate //compare day, month and year
      ) {
        return true;
      }
      if (
        date > twoWeekAfter //compare day, month and year
      ) {
        return true;
      }
      if (cutOffTimeEnable) {
        if (
          date <
          startDate.plus({
            days: cutOffDays,
          }) //compare day, month and year
        ) {
          return true;
        }
      }
      if (wholeDateIsBlackout(blackoutDates, date)) {
        return true;
      }

      if (date.equals(startDate)) {
        var dpDate = new Date(startDate.toISODate());
        var times = initPickupDeliveryTimes(
          selectedTS,
          preparationDeliveryBuffer,
          blackoutDates,
          isPickup,
          isDoorDash,
          operatingHours,
          orderPreparationTime,
          dpDate,
          getCurrentDate(startDate.zone.zoneName),
          0,
          false,
          15,
          deliveryTimeSlots,
          isDeliveryTimeSlotsEnable,
          preOrderCutOffTime
        );
        if (times.length == 0 || !times[0]) {
          return true;
        } else return false;
      }
      if (
        !IsStoreOpenOnDate(blackoutDates, operatingHours, isInOperation, date)
      ) {
        return true;
      } else {
        dpDate = new Date(date.toISODate());
        times = initPickupDeliveryTimes(
          selectedTS,
          preparationDeliveryBuffer,
          blackoutDates,
          isPickup,
          isDoorDash,
          operatingHours,
          orderPreparationTime,
          dpDate,
          getCurrentDate(startDate.zone.zoneName),
          0,
          false,
          15,
          deliveryTimeSlots,
          isDeliveryTimeSlotsEnable,
          preOrderCutOffTime
        );
        if (times.length == 0 || !times[0]) {
          return true;
        }
      }
    },
  };
}

export function IsStoreOpenOnDate(
  blackoutDates,
  operatingHours,
  isInOperation,
  date
) {
  let todayStr = weekdays[date.weekday];
  let todayeOperatinHours = operatingHours.find(
    (p) => p.DayOfWeek.toLowerCase() == todayStr
  );

  if (!isInOperation) {
    return false;
  }
  if (wholeDateIsBlackout(blackoutDates, date)) {
    return false;
  }
  return applyBlackoutToOperatingHours(
    blackoutDates,
    todayeOperatinHours,
    date
  );
}

export function IsStoreOpenAtTime(
  blackoutDates,
  operatingHours,
  isInOperation,
  now
) {
  if (!isInOperation) return false;
  if (wholeDateIsBlackout(blackoutDates, now)) return false;
  let operatinHours = IsStoreOpenOnDate(
    blackoutDates,
    operatingHours,
    isInOperation,
    now
  );
  if (operatinHours) {
    var result =
      isTimestrAfterCurrentDate(
        now.toFormat("HH:mm:ss"),
        operatinHours.OpeningTime
      ) &&
      isTimestrAfterCurrentDate(
        operatinHours.ClosingTime,
        now.toFormat("HH:mm:ss")
      );
    return result;
  }
  return false;
}

export function getDayOfWeekSurcharge(time) {
  let now = time;
  let DayOfWeekLabel;
  switch (now.toFormat("cccc").toLowerCase()) {
    case "monday":
      DayOfWeekLabel = 1;
      break;
    case "tuesday":
      DayOfWeekLabel = 2;
      break;
    case "wednesday":
      DayOfWeekLabel = 3;
      break;
    case "thursday":
      DayOfWeekLabel = 4;
      break;
    case "friday":
      DayOfWeekLabel = 5;
      break;
    case "saturday":
      DayOfWeekLabel = 6;
      break;
    case "sunday":
      DayOfWeekLabel = 0;
      break;
    default:
      DayOfWeekLabel = 7;
      break;
  }
  return DayOfWeekLabel;
}
export function getServerTime() {
  if (store) {
    let dt = window.serverTime || new Date();
    dt = typeof dt === "object" ? dt : new Date(dt);
    const tz = store.getters.selectedCompany.TimezoneIanaFormat || "";
    if (tz) {
      const zoneDt = DateTime.fromJSDate(dt).setZone(tz);
      dt = zoneDt.isValid ? zoneDt.toJSDate() : dt;
    }
    return dt;
  }
  return new Date();
}
